import React from 'react'
import Box from "@mui/material/Box";

import './CalculatePage.scss'
import {CalcPageInfo} from "./CalcPageInfo";
import {CalcListingsDrawer} from "./CalcListingsDrawer";
import classnames from "classnames";
import Stack from "@mui/material/Stack";
import {useCalcContext} from "../../contexts/CalcContext";
import Button from "@mui/material/Button";
import ReplayIcon from '@mui/icons-material/Replay';
import {MiniLeadItem} from "../DealPage/DealCRMPage/MiniLeadItem";
import {useModalsStore} from "../../stores/modalsStore";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useThemeStore} from "../../stores/themeStore";
import {CrmReturnLink} from "../../components/CrmReturnLink";

export const CalculatePage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { calcState, resetCalcState, getLeadId, opportunity } = useCalcContext()
    // Opened from a CRM opportunity: its person leads the header as a way back.
    const opportunityPerson = opportunity?.person_detail?.id ? opportunity.person_detail : null
    const theme = useThemeStore((state) => state.theme)

    const isPurchase = calcState.is_purchase

    // data-theme on the page root selects the palette block in SCSS.
    return (
        <Box id={"CalculatePage"}
             data-theme={theme}
             className={classnames('', {
                 isPurchase: isPurchase
             })}
        >
            <Stack
                justifyContent={'flex-start'}
                style={{ width: '100%' }}
            >
                {/* Header + car/location/pricing boxes share one centered,
                    content-width column so the "Calculate" title left-aligns
                    with the first box while the group stays centered. */}
                <div
                    className={'calc-top'}
                    style={{
                        width: isTabletOrMobile ? '100%' : 'fit-content',
                        maxWidth: '100%',
                        margin: isTabletOrMobile ? 0 : '0 auto',
                    }}
                >
                    <div className={'header'} style={{ marginBottom: '28px' }}>
                        <Stack
                            justifyContent={isTabletOrMobile ? "space-between" : 'flex-start'}
                            direction="row"
                            alignItems={'center'}
                            gap={'14px'}
                            sx={{
                                padding: isTabletOrMobile ? '0 16px': '',
                            }}
                        >
                            {
                                opportunityPerson
                                    ? <CrmReturnLink person={opportunityPerson}/>
                                    : <span className={'calc-page-title'}>Calculate</span>
                            }
                            {
                                getLeadId() &&
                                    <React.Fragment>
                                        <span style={{color: 'var(--text-secondary)', fontSize: '14px'}}> for lead</span>
                                        <MiniLeadItem leadId={getLeadId()}/>
                                    </React.Fragment>
                            }
                            <Button
                                className={'calc-reset-button'}
                                onClick={resetCalcState}
                            >
                                <ReplayIcon/> Reset
                            </Button>
                        </Stack>
                    </div>

                    <CalcPageInfo />
                </div>

                <CalcListingsDrawer />
            </Stack>
        </Box>
    )
}